import * as React from 'react';
import { flushSync } from 'react-dom';
import { usePaginationContext } from '../contexts/PaginationContext';
const useSearchField = () => {
  const [searchValue, setSearchValue] = React.useState('');
  const timeoutRef = React.useRef(null);
  const {
    setPage
  } = usePaginationContext();
  const handleChangeInput = React.useCallback(value => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      flushSync(() => {
        setPage(0);
        setSearchValue(value);
      });
    }, 400);
  }, [setPage, setSearchValue]);
  return {
    handleChangeInput,
    searchValue
  };
};
export default useSearchField;